import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wave-bottom-decorated-one',
  templateUrl: './wave-bottom-decorated-one.component.html'
})
export class WaveBottomDecoratedOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
